import * as Sentry from '@sentry/browser'
import { router } from '@/router'

const RELOAD_FLAG_KEY = 'chunk-error-reload-attempted'
const HEALTHY_RESET_DELAY_MS = 10000

const isChunkLoadError = error => {
	const message = error?.message || String(error || '')
	return /Loading (CSS )?chunk [\w.-]+ failed|Failed to fetch dynamically imported module|ChunkLoadError/i.test(message)
}

const recoverFromChunkError = error => {
	if (!isChunkLoadError(error)) {
		return false
	}

	Sentry.addBreadcrumb({ category: 'chunk-load', message: 'Chunk load error detected', level: 'warning' })

	if (sessionStorage.getItem(RELOAD_FLAG_KEY)) {
		Sentry.captureException(error)
		return true
	}

	sessionStorage.setItem(RELOAD_FLAG_KEY, '1')
	window.location.reload()
	return true
}

router.onError(recoverFromChunkError)

window.addEventListener('unhandledrejection', event => {
	if (recoverFromChunkError(event.reason)) {
		event.preventDefault()
	}
})

window.addEventListener('load', () => {
	setTimeout(() => sessionStorage.removeItem(RELOAD_FLAG_KEY), HEALTHY_RESET_DELAY_MS)
})
